import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'

Vue.component('ApexChart', VueApexCharts)